export const trackingEventNames = {
  pageView: 'vpv-devotion-wall',
  shareHeart: 'share_heart',
  shopNow: 'shop_now',
  followDGBeauty: 'follow_dg_beauty',
  restartTheExperience: 'restart_the_experience',
}
